import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon, ActivityIcon, HeartPulseIcon } from 'lucide-react';
const reasons = [{
  icon: TrendingDownIcon,
  title: 'El Mito del Déficit Calórico',
  description: 'Te dijeron que comieras poco. Pero a los 50, comer poco eleva el cortisol (la hormona del estrés), y tu cuerpo, asustado por la falta de energía, se aferra a la grasa abdominal como un náufrago a una balsa.'
}, {
  icon: ActivityIcon,
  title: 'El Cardio Infinito',
  description: 'Caminar horas o hacer aeróbicos de alto impacto solo inflaman tus articulaciones y agotan tus niveles de magnesio, sin tocar las reservas de grasa.'
}, {
  icon: HeartPulseIcon,
  title: 'El Olvido Hormonal',
  description: 'Las dietas estándar ignoran que tras los 50, tus estrógenos han caído. Sin ellos, tu cuerpo procesa los carbohidratos de forma distinta.'
}];
export function WhyFailed() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-172">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-12 text-center" data-id="element-174">
          Por qué fallaron tus intentos anteriores
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-175">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border-2 border-sage-primary rounded-xl p-6 hover:shadow-lg transition-shadow" data-id="element-176">
              <reason.icon className="w-10 h-10 text-sage-dark mb-4" data-id="element-177" />
              <h3 className="font-serif text-xl text-forest mb-3" data-id="element-178">
                {reason.title}
              </h3>
              <p className="text-forest/70 leading-relaxed" data-id="element-179">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}